import {Drawer, FormControl, FormControlLabel, Radio, RadioGroup, Stack} from "@mui/material";
import {useEffect, useState} from "react";
import type {BasePayers} from "../../firebase/index.js";
import {addPayer, PayerModel, TripModel} from "../../firebase/index.js";
import {useInMemoryTrip} from "../../redux/InMemoryTripReducer.js";
import APXActionButtons from "../../reusables/APXActionButtons.jsx";
import type {BSLProps} from "../../reusables/js/APXBottomSheetLayoutUtils.js";
import useBottomSheet from "../../reusables/js/APXBottomSheetLayoutUtils.js";


export default function FreezePayerBSL({uid, onClose, payers}: BSLProps & { payers: BasePayers }) {
	  const [selectedPayerKey, setSelectedPayerKey] = useState("");
	  
	  const inMemoryTrip: TripModel = useInMemoryTrip();
	  
	  const {isOpen, handleOpen, handleClose} = useBottomSheet({initialState: true, onClose});
	  
	  const handleCancel = () => {
			 onClose();
	  };
	  
	  const handleFreeze = () => {
			 if (/*FALSY->*/ !!!uid) {
					alert("Please login to add a new reimbursement");
					return;
			 }
			 if (/*FALSY->*/ !!!selectedPayerKey) {
					alert("Please select a payer to freeze");
					return;
			 }
			 
			 const payer: PayerModel = payers[selectedPayerKey];
			 
			 payer.freeze();
			 
			 addPayer(uid, inMemoryTrip.expenditureKey, selectedPayerKey, payer);
			 
			 handleCancel();
	  };
	  
	  useEffect(() => {
			 if (/*TRUTHY->*/ !!payers) {
					if (Object.values(payers).every((payer: PayerModel) => /*NOT->*/ !payer.isFreezable())) {
						  alert("There are no freezable payers");
						  handleCancel();
					}
			 }
	  }, [payers]);
	  
	  return (
				 <Drawer anchor="bottom" open={isOpen} onClose={handleClose} variant="temporary">
						<Stack spacing={2} p={2}>
							  <FormControl>
									 <RadioGroup value={selectedPayerKey}
													 onChange={(event) => setSelectedPayerKey(event.target.value)}
									 >
											{
												  /*TRUTHY->*/ !!payers &&
													  Object.keys(payers).map((payerKey) => {
															 const payer: PayerModel = payers[payerKey];
															 return (
																		<FormControlLabel
																				  key={payerKey}
																				  control={<Radio/>}
																				  label={payer.name}
																				  value={payerKey}
																				  disabled={/*NOT->*/ !payer.isFreezable()}
																		/>
															 );
													  })
											}
									 </RadioGroup>
							  </FormControl>
							  <APXActionButtons onCancel={handleCancel} onAdd={handleFreeze} positiveText={"freeze"}
													  disablePositiveByDefault={/*FALSY->*/ !!!selectedPayerKey}
													  shouldShowConfirmationDialog={true}
							  />
						</Stack>
				 </Drawer>
	  );
}